/* Import External Modules */
import React from 'react';

/* Import Leverege Modules*/
import { GlobalState, Select } from '@leverege/ui-redux';
import { Dialog, Dialogs, Toast } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';

/* Import Local Modules */
import Icons from "../../Icons.js";
import ShareTemporaryUserAccess from "./ShareTemporaryUserAccess.js";
const {
  t
} = I18N.ns('temporaryUserManagement.action.Reset.Dialog');

/**
 * Resets a given temporary user
 */
async function onResetTemporaryUser({
  data
}) {
  // Get parameters
  const {
    user,
    actions,
    onClose,
    reqData
  } = data;
  // Try to remove users
  try {
    const {
      validAfter,
      expiresAt
    } = user;
    const temporaryUser = await GlobalState.dispatch(actions.temporaryUser(user).renew({
      validAfter,
      expiresAt
    }));
    Dialogs.show({
      id: 'temporaryUserManagement.action.PostCreateShare',
      component: ShareTemporaryUserAccess,
      props: {
        ...data,
        temporaryUser
      }
    });
    await GlobalState.dispatch(Select.clear('resourceTemporaryUsersTargeted'));
    // Successfully removed users
    Toast.success(t('toastSuccess', {
      user
    }));
    return onClose();
  } catch (error) {
    console.log(error);
    Toast.error(t('toastError'), error.message);
    return onClose();
  }
}

/**
 * Remove users dialog.
 */
export default function ResetTemporaryUserDialog(props) {
  // Get parameters
  const {
    onClose,
    show
  } = props;

  // Render component
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    dialogTitleVariant: "tempUserEditorTitle|questionTitle|dialogTitle",
    show: show,
    eventData: {
      ...props
    },
    title: t('title'),
    icon: Icons.resetTemporaryUserDialogIcon,
    message: t('message'),
    okay: t('okay'),
    okayVariant: "primary",
    onCancel: onClose,
    onOkay: onResetTemporaryUser
  });
}